// utils/menuCache.ts

/**
 * Cache keys for menu data
 */
export const CACHE_KEYS = {
  HEADER_MENU: 'headerMenuResponse',
  FOOTER_MENU: 'footerMenuResponse',
} as const;

/**
 * Get cached menu data from localStorage
 */
export const getCachedMenuData = (key: string): any | null => {
  if (typeof window === 'undefined') return null;
  
  try {
    const cached = localStorage.getItem(key);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (error) {
    console.error('Error reading menu cache:', error);
  }
  return null;
};

/**
 * Set menu data in localStorage cache
 */
export const setCachedMenuData = (key: string, data: any): void => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Error setting menu cache:', error);
  }
};

/**
 * Clear specific menu cache
 */
export const clearMenuCache = (key: string): void => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error clearing menu cache:', error);
  }
};

/**
 * Clear all menu caches (header + footer)
 */
export const clearAllMenuCache = (): void => {
  clearMenuCache(CACHE_KEYS.HEADER_MENU);
  clearMenuCache(CACHE_KEYS.FOOTER_MENU);
};

/**
 * Clear header menu cache - call this when header menu or CMS settings are updated
 */
export const clearHeaderMenuCache = (): void => {
  clearMenuCache(CACHE_KEYS.HEADER_MENU);
};

/**
 * Clear footer menu cache - call this when footer menu is updated
 */
export const clearFooterMenuCache = (): void => {
  clearMenuCache(CACHE_KEYS.FOOTER_MENU);
};

/**
 * Clear menu cache based on menu group
 */
export const clearMenuCacheByGroup = (menuGroup: string): void => {
  if (menuGroup === 'header') {
    clearHeaderMenuCache();
  } else if (menuGroup === 'footer') {
    clearFooterMenuCache();
  } else {
    // For other menu groups or if unsure, clear all
    clearAllMenuCache();
  }
};